import React, { useState, useEffect } from 'react';
import './CourtPrice.css';
import { useUser } from '../context/UserContext';
import Swal from 'sweetalert2';
import Select from 'react-select';


const CourtPrice = () => {
  const { selectedCenter } = useUser();
  const [sport, setSport] = useState('');
  const [court, setCourt] = useState([]);
  const [pricingData, setPricingData] = useState([]);
  const [timeSlots, setTimeSlots] = useState([]);
  const [daysOfWeek, setDaysOfWeek] = useState([]);
  const [sportsList, setSportsList] = useState([]);
  const [courtsList, setCourtsList] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('auth-token');
  const parseTimeToMinutes = (timeStr) => {
    const [time, modifier] = timeStr.split(' ');
    let [hours, minutes] = time.split(':').map(Number);

    if (modifier === 'PM' && hours !== 12) {
      hours += 12;
    } else if (modifier === 'AM' && hours === 12) {
      hours = 0;
    }

    return hours * 60 + minutes;
  };

  useEffect(() => {
    if (!sport || !selectedCenter) {
      setPricingData([]);
      return;
    }

    const fetchCourtAndTimings = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_COURT_PRICING}?academyId=${selectedCenter}&sportId=${sport}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
          }
        );
        const result = await response.json();

        if (result.success) {
          const { courts, slotPricing, Weekdays, sportId } = result.data;
          setCourtsList(courts || []);
          const sortedSlots = Object.keys(slotPricing).sort((a, b) => {
            return parseTimeToMinutes(a) - parseTimeToMinutes(b);
          });
          setTimeSlots(sortedSlots);

          setDaysOfWeek(Weekdays || daysOfWeek);
          mapPricingData(slotPricing, Weekdays || daysOfWeek);
          if (sportId && !sport) {
            setSport(sportId);
          }
        }

      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    fetchCourtAndTimings();
  }, [sport, selectedCenter]);

  useEffect(() => {
    if (!sport || !selectedCenter) return;

    const fetchData = async () => {
      setLoading(true);
      try {
        const url = court.length === 0
          ? `${process.env.REACT_APP_API_COURT_PRICING}?academyId=${selectedCenter}&sportId=${sport}`
          : `${process.env.REACT_APP_API_COURT_PRICING}?academyId=${selectedCenter}&sportId=${sport}&courtIds=${court.join(',')}`;

        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        const result = await response.json();

        if (result.success) {
          const { courts, slotPricing, Weekdays, sportId } = result.data;
          if (Weekdays) setDaysOfWeek(Weekdays);
          if (courts) setCourtsList(courts);
          const sortedSlots = Object.keys(slotPricing).sort((a, b) => {
            return parseTimeToMinutes(a) - parseTimeToMinutes(b);
          });
          setTimeSlots(sortedSlots);

          if (sportId && !sport) {
            setSport(sportId);
          }
          mapPricingData(slotPricing, Weekdays || daysOfWeek);
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [court, sport, selectedCenter]);



  const mapPricingData = (slotPricing, weekdays) => {
    const updatedPricingData = [...pricingData];

    Object.keys(slotPricing).forEach((timeSlot, timeIndex) => {
      if (!updatedPricingData[timeIndex]) {
        updatedPricingData[timeIndex] = [];
      }

      slotPricing[timeSlot].forEach((dayData, dayIndex) => {
        const weekdayIndex = weekdays.indexOf(dayData.weekDays);
        if (weekdayIndex !== -1) {
          if (!updatedPricingData[timeIndex][weekdayIndex]) {
            updatedPricingData[timeIndex][weekdayIndex] = '';
          }
          updatedPricingData[timeIndex][weekdayIndex] = dayData.price || '';
        }
      });
    });

    setPricingData(updatedPricingData);
  };

  const handlePriceChange = (timeIndex, dayIndex, value) => {
    const updatedPricingData = [...pricingData];
    updatedPricingData[timeIndex][dayIndex] = value;
    setPricingData(updatedPricingData);
  };

  const handleSubmit = async () => {
    if (!sport || court.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Missing Selection',
        text: 'Please select Sport and Court.',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }

    if (!pricingData || pricingData.length === 0) {
      Swal.fire({
        icon: 'error',
        title: 'Pricing Data Error',
        text: 'Pricing data is missing or not yet loaded.',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }

    const data = {};

    timeSlots.forEach((time, timeIndex) => {
      daysOfWeek.forEach((day, dayIndex) => {
        const price = pricingData[timeIndex]?.[dayIndex];
        if (price) {
          const key = `${time}$${day}`;
          data[key] = parseFloat(price);
        }
      });
    });

    const payload = {
      academyId: selectedCenter,
      sportId: sport,
      courtIds: court,
      data: data,
    };


    try {
      const response = await fetch(process.env.REACT_APP_API_COURT_PRICING, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (result.success) {
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'Pricing updated successfully!',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
        });
      } else {
        const errorMessage = result.data?.errorMessage || result.success_message || 'Unknown error';
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: 'Failed to update pricing: ' + errorMessage,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Network Error',
        text: 'Error submitting pricing data. Please try again later.',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };

  useEffect(() => {
    if (!selectedCenter) return;

    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_COURT_PRICING}?academyId=${selectedCenter}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
          }
        );
        const result = await response.json();

        if (result.success) {
          const { slotPricing, Weekdays, academySports, courts, sportId } = result.data;

          setDaysOfWeek(Weekdays);
          const sortedSlots = Object.keys(slotPricing).sort((a, b) => {
            return parseTimeToMinutes(a) - parseTimeToMinutes(b);
          });
          setTimeSlots(sortedSlots);

          setSportsList(academySports || []);
          setCourtsList(courts || []);
          if (sportId && !sport) {
            setSport(sportId);
          }
          mapPricingData(slotPricing, Weekdays);
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedCenter]);


  useEffect(() => {
    if (!sport || !selectedCenter) return;

    if (court.length === 0) {
      setPricingData([]);
      return;
    }

    const fetchCourtAndTimings = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_COURT_PRICING}?academyId=${selectedCenter}&sportId=${sport}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
          }
        );
        const result = await response.json();

        if (result.success) {
          const { courts, slotPricing } = result.data;
          setCourtsList(courts || []);
          const sortedSlots = Object.keys(slotPricing).sort((a, b) => {
            return parseTimeToMinutes(a) - parseTimeToMinutes(b);
          });
          setTimeSlots(sortedSlots);

          mapPricingData(slotPricing, daysOfWeek);
        }
      } catch (error) {

      } finally {
        setLoading(false);
      }
    };

    fetchCourtAndTimings();
  }, [sport]);


  return (
    <div className="enrollment-container">
      <div className="select-container">
        <label className="select-label">
          Select Sport:
          <Select
            options={sportsList.map(sportItem => ({
              value: sportItem.sportId,
              label: sportItem.sport.name,
            }))}
            value={sportsList
              .map(sportItem => ({
                value: sportItem.sportId,
                label: sportItem.sport.name,
              }))
              .find(option => option.value === sport)}
            onChange={(selectedOption) => {
              setSport(selectedOption.value);
            }}
            menuPortalTarget={document.body}
            placeholder="Select a Sport"
          />

        </label>



        <label className="select-label">
          Select Courts:
          <Select
            isMulti
            options={courtsList.map(court => ({
              value: court.id,
              label: court.name
            }))}
            value={courtsList
              .filter(court => court && court.id && court.name)
              .filter(court => Array.isArray(court) || true)
              .map(court => ({
                value: court.id,
                label: court.name
              }))
              .filter(option => court.includes(option.value))
            }
            placeholder="Select Court"
            menuPortalTarget={document.body}
            onChange={(selectedOptions) => {
              const selectedIds = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
              setCourt(selectedIds);
            }}
          />
        </label>

      </div>
<div style={{overflow:'scroll'}}>
      <table className="pricing-table">
        <thead>
          <tr>
            <th>Time</th>
            {daysOfWeek.map((day) => (
              <th key={day}>{day}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {timeSlots.map((time, timeIndex) => (
            <tr key={time}>
              <td>{time}</td>
              {daysOfWeek.map((day, dayIndex) => (
                <td key={day}>
                  <input
                    className="price-input"
                    type="text"
                    placeholder="Price"
                    value={pricingData[timeIndex] && pricingData[timeIndex][dayIndex]}
                    onChange={(e) => handlePriceChange(timeIndex, dayIndex, e.target.value)}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      </div>
      <button className="create-button" onClick={handleSubmit}>Submit</button>
    </div>
  );
};

export default CourtPrice;
